/* eslint-disable no-redeclare */
import type { z } from 'zod';

import { Integer } from './integer';

export const HouseholdSize = Integer;

export type HouseholdSize = z.infer<typeof HouseholdSize>;
